import { Component, ElementRef, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { APP_CONFIG } from '../../app.config';
import { DateUtilsService } from '../../common/date-utils.service';
import { LanguageCheckService } from '../../common/language-check.service';
import { Language, LanguageService } from '../../common/language.service';
import { LogoService } from '../../common/logo.service';
import { MarshallerFactory } from '../../common/marshaller-factory';
import { ScannerService } from '../../common/scanner.service';
import { ValueListsService } from '../../common/value-lists.service';
import { AppConfig } from '../../models/config/app-config';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  providers: [ScannerService]
})
export class HeaderComponent {
  get barcode(): string {
    return this._barcode;
  }

  set barcode(value: string) {
    this._barcode = value;
  }

  private _barcode = '';

  hasFileLoadError = false;

  umgebung: string;

  @Output()
  antragLoaded = new EventEmitter<any>();

  @Output()
  antragReset = new EventEmitter<void>();

  @ViewChild('neuerAntrag', { static: true })
  neuerAntrag: ElementRef;

  @ViewChild('scanBarcode', { static: true })
  scanBarcode: ElementRef;

  @ViewChild('loadFile', { static: true })
  loadFile: ElementRef;

  selectedLanguage: Language;

  constructor(
    private languageService: LanguageService,
    private languageCheckService: LanguageCheckService,
    private modalService: NgbModal,
    private scannerService: ScannerService,
    private valuelistService: ValueListsService,
    private dateUtils: DateUtilsService,
    private marshallerFactory: MarshallerFactory,
    public logoService: LogoService,
    @Inject(APP_CONFIG) public appConfig: AppConfig
  ) {
    this.umgebung = appConfig.umgebung;
    this.selectedLanguage = this.languageService.getLanguage();
  }

  async onNeuerAntragClicked() {
    await this.modalService.open(this.neuerAntrag).result.then(
      (result) => {
        if (result === 'ok') {
          this.antragReset.emit();
        }
      }
    );
  }

  async onScanBarcode() {
    this.barcode = '';
    await this.modalService.open(this.scanBarcode).result.then(
      (result) => {
        if (result === 'ok' && this.barcode) {
          this.scannerService.decodeBarcodeToAntrag(this.barcode)
          .subscribe(
            (antrag: any) => {
              this.antragLoaded.emit(this.readAntrag(antrag));
            });

        }
      },
      () => null
    );
  }

  async onLoadFile() {
    await this.modalService.open(this.loadFile, { size: 'lg' }).result.then(
      (result) => {
        if (result.result === 'ok') {
          const files: FileList = result.payload;

          if (!files || files.length === 0) {
            return;
          }
          this.antragReset.emit();
          const reader: FileReader = new FileReader();

          reader.onload = () => {
            const json: string = reader.result as string;

            if (json) {
              try {
                const obj: any = this.readAntrag(JSON.parse(json));
                this.antragLoaded.emit(obj);
                this.hasFileLoadError = false;
              } catch (e) {
                this.hasFileLoadError = true;
                this.onLoadFile();
              }
            }
          };
          reader.readAsText(files.item(0));
        }
      }
    );
  }

  /**
   * To change the language we need to navigate to a different url with a translated version of the app,
   * because language needs to be defined at build-time, and we cannot change it dynamically.
   */
  switchLanguage() {
    this.languageCheckService.switchLanguage(this.selectedLanguage);
  }

  private readAntrag(antrag: any): any {
    const dateFormatter = this.dateUtils.getFormatter('yMd');
    const marshaller = this.marshallerFactory.createMarshaller(this.valuelistService, dateFormatter, this.appConfig);
    return marshaller.unmarshall(antrag);
  }

}
